import { injectIntl } from 'react-intl';
import React, { useState, useEffect, useContext } from 'react';
import { CommonHandleCancelPayment } from '@/components/H5PC/CommonMethod';

import myContext from '@/utils/createContext';


function ThemeMobile(props) {
	const { intl } = props;
	const { formatMessage } = intl;
	const data = useContext(myContext);
	const { isMobileView, showDomain, key, resData, merchantTheme } = useContext(myContext);

	return (
		<div className="vh5pc-cashier-mobile-top">
			<div className="vh5pc-cashier-mobile-top-title">
				{/* Payment */}
				{formatMessage({ id: 'ga-checkout.payment' })}
			</div>
			{/* 取消支付，跳转到 cancelUrl */}
			<div className="vh5pc-cashier-mobile-top-cancel">
				<span
				onClick={() =>
					CommonHandleCancelPayment(props, resData, key, isMobileView)
				}
				>
				{/* Cancel */}
				{formatMessage({ id: 'ga-checkout.cancel' })}
				</span>
			</div>
			<div className="h5pc-container-line"></div>
		</div>
	)
}

export default injectIntl(ThemeMobile);